import { render, staticRenderFns } from "./RegisterDomain.vue?vue&type=template&id=3c2ae53c&scoped=true&"
import script from "./RegisterDomain.vue?vue&type=script&lang=js&"
export * from "./RegisterDomain.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDomain.vue?vue&type=style&index=0&id=3c2ae53c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2ae53c",
  null
  
)

export default component.exports